import React, { useEffect, useRef, useState, useMemo } from "react";
import { Group } from "@/stores/clip/class/Track";

interface CommonItemProps {
  trackItem: Group;
  itemIndex: number;
  config: {
    [key: string]: any;
  };
}

const CommonItem: React.FC<CommonItemProps> = ({
  trackItem,
  itemIndex,
  config,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    console.log(trackItem.materials);
  }, []);

  const waveStyle = useMemo(() => {
    const { start, end, offsetL, offsetR, frameCount } = trackItem;
    const showFrameCount = end - start;
    return {
      transformOrigin: "left top",
      left: `-${(offsetL / showFrameCount) * 100}%`,
      right: `-${(offsetR / showFrameCount) * 100}%`,
      width: `${(frameCount / showFrameCount) * 100}%`,
    };
  }, [trackItem]);

  return (
    <div
      className="sticker-group"
      style={{
        overflow: "hidden",
        background: config.background,
        borderRadius: 6,
        height: config.height || "100%",
        userSelect: "none",
      }}
      ref={containerRef}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          borderRadius: "0 0 8px 8px",
          fontSize: 14,
          ...waveStyle,
        }}
      >
        <div
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            padding: "0 10px",
          }}
        >
          从{trackItem.materials.length}个{trackItem.name}中随机
        </div>
      </div>
    </div>
  );
};

export default CommonItem;
